//this is the access where we will assign the user role to give edit uodate and viewAccess
export const RolesAccess = {
  editAccess:["Admin","Manager","Super Admin"],
  updateAccess:["Admin","Manager","Super Admin"],
  viewAccess:["Admin","Manager","HR","Super Admin"],
  deleteAccess:["Admin","Manager","Super Admin"],
  addAccess:["Admin","Manager","Super Admin"]
}
